import React from 'react';

export const MenuFooter = ({ menuItems: MenuItems }) => (
  <div className="menu__footer">{MenuItems ? MenuItems : <></>}</div>
);
